export enum Fonts
{
    h1= "h1",h2= "h2",h3= "h3",h4= "h4",h5= "h5",h6= "h6",h7= "h7",h8= "h8",h9= "h9", h10="h10", h11="h11", h12= "h12", h13="h13",
    h14= "h14", h15 = "h15", h16 = "h16"
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/fonts.ts